import React, { useRef, useEffect } from 'react';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { Row } from '@amzn/atoz-web/Row';
import { IconChevronLeft, IconChevronRight } from '@amzn/atoz-web/Icons';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { useBreakpoints } from '@amzn/atoz-web/Responsive';
import { PageNames, BIAnalytics } from '@amzn/atoz-shiftapp-utilities';
import { DayCard } from './DayCard';
import { updateDateQueryParam } from '../../hooks';
import { useTranslation } from 'react-i18next';
export function scrollRight(containerRef) {
    if (containerRef.current) {
        var updatedScrollPosition = containerRef.current.scrollLeft + containerRef.current.offsetWidth;
        containerRef.current.scrollTo(updatedScrollPosition, 0);
    }
}
export function scrollLeft(containerRef) {
    if (containerRef.current) {
        var updatedScrollPosition = containerRef.current.scrollLeft - containerRef.current.offsetWidth;
        containerRef.current.scrollTo(updatedScrollPosition, 0);
    }
}
export var DaySelector = function (_a) {
    var daysWithCount = _a.daysWithCount, currentSelectedDay = _a.currentSelectedDay, setCurrentSelectedDay = _a.setCurrentSelectedDay, _b = _a.isDarkBg, isDarkBg = _b === void 0 ? false : _b, _c = _a.analyticsPageName, analyticsPageName = _c === void 0 ? PageNames.FIND_SHIFTS : _c, observerRef = _a.observerRef;
    var containerRef = useRef(null);
    var t = useTranslation().t;
    var matches = useBreakpoints().matches;
    var isLargerViewport = matches.l || matches.xl;
    // update date param on mount
    useEffect(function () {
        updateDateQueryParam(currentSelectedDay);
    }, []);
    return (React.createElement(StyledRow, { gridGap: "S200", padding: { top: 'S200', bottom: 'S200' }, dataTestId: "day-selector" },
        isLargerViewport && (React.createElement(Button, { onClick: function () { return scrollLeft(containerRef); }, dataTestId: "left-chevron", variant: ButtonVariant.Tertiary, icon: React.createElement(IconChevronLeft, { title: "scrollLeft", color: isDarkBg ? 'neutral0' : 'neutral100' }), "aria-label": t('shift_management_features_DaySelector_scrollLeft') })),
        React.createElement(NoScrollBarRow, { ref: observerRef ? observerRef(containerRef) : containerRef, gridGap: "S200", overflow: "scroll", padding: { top: 'S300', bottom: 'S300', left: 'S300' }, role: "tablist" }, daysWithCount.map(function (_a) {
            var date = _a.date, count = _a.count;
            return (React.createElement(DayCard, { date: date, selected: date.toISODate() == currentSelectedDay.toISODate(), setSelectedDay: function (newDate) {
                    BIAnalytics.selectDifferentDate(newDate.toISO(), analyticsPageName);
                    updateDateQueryParam(newDate);
                    setCurrentSelectedDay(newDate);
                }, numberOfShifts: count, isLargerViewport: isLargerViewport, key: date.toMillis() }));
        })),
        isLargerViewport && (React.createElement(Button, { onClick: function () { return scrollRight(containerRef); }, dataTestId: "right-chevron", variant: ButtonVariant.Tertiary, icon: React.createElement(IconChevronRight, { title: "scrollRight", color: isDarkBg ? 'neutral0' : 'neutral100' }), "aria-label": t('shift_management_features_DaySelector_scrollRight') }))));
};
var NoScrollBarRow = styledWithTheme(Row)(function () { return "\n    &::-webkit-scrollbar {\n        display: none;\n    }\n    -ms-overflow-style: none;\n    scrollbar-width: none;"; });
var StyledRow = styledWithTheme(Row)(function (_a) {
    var theme = _a.theme;
    return "\n        box-shadow: 0px 1px 0px ".concat(theme.selectors.color('neutral30'), ";\n        margin-bottom: 1px;\n    ");
});
